import axios from "axios";

// The Stand's own small API helper: always answers { ok, data, error, code }, so the panel can show errors in place.
const base = () => `${process.env.REACT_APP_BASE_URL}/api/`;
const headers = () => ({ Authorization: `Bearer ${localStorage.token}` });
const wrap = (request) => request.then(
  (r) => ({ ok: true, data: (r.data && r.data.data) || {}, message: r.data && r.data.message, code: r.status }),
  (e) => {
    const body = (e.response && e.response.data) || {};
    return {
      ok: false,
      code: e.response ? e.response.status : 0,
      data: body.data || {},
      error: body.message || "We couldn’t reach TheNewspaperStand just now. Please try again.",
    };
  }
);

export const standGet = (url) => wrap(axios.get(`${base()}${url}`, { headers: headers() }));
export const standPost = (url, body) => wrap(axios.post(`${base()}${url}`, body || {}, { headers: headers() }));
